import ActionsForm from '@/shared/mixins/actionsForm'
import tableQma from '../tableQma/tableQma.vue'

export default {
  name: 'collapseApr',
  props: ['tipoFluxo'],
  mixins: [ActionsForm],
  components: {tableQma},
  data () {
    return {
      tabs: 0,
      tabIndex: 0,
      formSearch: {},
      changeAngel: false,
      columTemplate: ['DESCRIÇÃO'],
      arquivoCarregamento: false,
      tipoAssinatura: 0,
      tipoCabecalho: 1,
      itemArray: [],
      openSections: [],
      lista: [{nome: 'ASSINATURA', tipo: 0}, {nome: 'CABEÇALHO', tipo: 1}],
      form: {},
      formAdd: {
        Nome: '',
        Categoria: 0,
        CodigoAtividade: null,
        DataAlteracao: '',
        Descricao: '',
        Id: null
      },
      listavazia: {
        categoria: 0
      },
      titlePopup: '',
      EditOrAdd: false,
      nomeLista: '',
      deleteDescricao: {}
    }
  },
  methods: {
    changeAcording (value) {
      this.changeAngel = !this.changeAngel
      this.arquivoCarregamento = !this.arquivoCarregamento
    },
    recolherTodos () {
      this.openSections = []
    },
    expandirTodos () {
      this.openSections = this.lista.map((data, index) => {
        if (this.$refs.table && this.$refs.table[index]) {
          this.$refs.table[index].defineCabecalho(index)
        }
      })
      this.openSections = this.lista.map((data, index) => index)
    },
    expandirFiltro () {
      if (this.tabIndex === 0) {
        this.$refs.table.formSearch = this.formSearch
        this.$refs.table.onLoadTable(this.tabIndex)
      } else {
        this.$refs.tableCabecalho.formSearch = this.formSearch
        this.$refs.tableCabecalho.onLoadTable(this.tabIndex)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/registerbasicQMA/components/collapseQma/collapseQma.js